(function () {
	'use strict';

	angular.module('KimaMain').directive('agencyCityMap', agencyCityList);

	agencyCityList.$inject = [];

	function agencyCityList() {
		return {
			restrict: 'E',
			templateUrl: 'agency-city-map.html',
			scope: {
				onItemClick: '&?',
				onReady: '&?',
				citySelect: '=?',
				agencyList: '=?',
				reRender: '=?',
				infoboxTemplate: '@?',
				zoomTo: '@?',
				splashModal: '=?'
			},
			controller: 'AgencyCityListController',
			link: function(scope, elem, attrs) {
				
				elem.addClass('b-agency-city-map');
				elem.attr('id', 'agency-city-map-' + (+new Date()));
				
				// Tell controller to zoom to this city
				scope.zoomToCity = scope.zoomTo;
				
				if(scope.splashModal !== undefined) {
					scope.agenciesNarrowed = !scope.splashModal;
				}
				
				// Remove custom item click if it is not actually set (angular always binds it)
				if(!attrs.onItemClick) {
					scope.onItemClick = null;
				}
				
				scope.baseHref = function () {
					return document.getElementsByTagName('base')[0].href.replace(/\/+$/, '');
				};
			}
		};
	}

})();

